export default __webpack_public_path__ + "static/media/thumbnail-03.e2b8d2fd.png";